declare const window: any;
export const sendEvent = (
  componentName: string,
  eventName: string,
  label?: string,
  value?: string,
) => {
  import.meta.env.DEV &&
    // eslint-disable-next-line no-console
    console.log('send event: ', componentName, eventName, label, value);

  if (import.meta.env.DEV) {
    return;
  }
  // Send event to Google Analytics
  window.gtag('event', componentName, {
    event_category: eventName,
    event_label: label,
    value: value,
  });

  // Send event to Clarity
  window.clarity('set', eventName, componentName, label, value);
};

export const sendCookieConsentEvent = () => {
  if (import.meta.env.DEV) {
    return;
  }
  window.clarity('consentv2', {
    ad_Storage: 'granted',
    analytics_Storage: 'granted',
  });
};
